import { StateViewModel } from './stateViewModel';
import { PathViewModel } from './pathViewModel';

export class Path implements PathViewModel {
	constructor(public id: string, public name: string, public states: StateViewModel[]) {}

	public hasEndingState() {
		return this.states.some(s => this.isEndState(s));
	}

	public getStates() {
		return this.states.filter(s => !this.isEndState(s));
	}

	public getEndStates() {
		return this.states.filter(s => this.isEndState(s));
	}

	public isEndState(state: StateViewModel) {
		return state.component === 'HumanHandover' || state.component === 'GoTo';
	}
}
